import PropTypes from "prop-types";
import "./styles.scss";
import { motion } from "framer-motion";
import { usePadding } from "@/components/utils/Padding";

/* #META
 {
  "NAME": "Callout",
  "CLASSNAME": "callout-component",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const Callout = ({ data }) => {
  const { background_image, wording, small_callout } = data.callout_content || {};
  const paddingComponent = data?.padding_component || "";
  const backgroundImageUrl = background_image?.url || "";
  const textClassName = small_callout ? "mini-callout" : "callout";
  const words = wording.split(" ");

  const paddingStyle = usePadding(paddingComponent);

  return (
    <section className="callout-component" style={paddingStyle}>
      <div className="container-revamp callout-content xl:px-0">
        <p
          className={textClassName}
          style={{ backgroundImage: `url(${backgroundImageUrl})`, whiteSpace: "pre-wrap" }}
        >
          {words.map((word, wordIndex) => (
            <span key={wordIndex} className="inline-block mr-[0.25em]">
              {word.split("").map((letter, letterIndex) => (
                <motion.span
                  key={letterIndex}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: (wordIndex * 6 + letterIndex) * 0.05 }}
                  viewport={{ once: true }}
                  className="inline-block"
                >
                  {letter}
                </motion.span>
              ))}
            </span>
          ))}
        </p>
      </div>
    </section>
  );
};

Callout.propTypes = {
  data: PropTypes.shape({
    padding_component: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
    callout_content: PropTypes.shape({
      background_image: PropTypes.object,
      wording: PropTypes.string,
      small_callout: PropTypes.bool,
    }),
  }),
};

export default Callout;
